// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"065ec438","185":"9f883eee","213":"f4c100bc","264":"782f5851","329":"19191a9b","351":"94d65964","430":"fb90e6a8","453":"f8d20068","478":"623a9449","501":"914d6d99","673":"c729ca99","696":"cf3976f9","732":"b17f86c5","931":"e4b77de7","947":"128a1ee2"}[chunkId] + ".chunk.js";
};